<template>
  <div class="start">
    <button class="start__btn">Start</button>

    <!-- select -->
    <div class="start-select">
      <button class="start-select__title" v-text="selectedItem" />
      <ul class="start-select__list">
        <template v-for="(item, index) in items">
          <li v-if="item !== selectedItem" :key="index">
            <button v-text="item" @click="handleSelect(item)" />
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderStart",

  data() {
    const items = ["Random Single Mission", "Multiplayer", "PvP"];
    const [selectedItem] = items;

    return {
      selectedItem,
      items
    };
  },

  methods: {
    handleSelect(item) {
      this.selectedItem = item;
      this.$emit("select", item);
    }
  }
};
</script>

<style>
@import "./start.css";
</style>
